import { render, staticRenderFns } from "./SolicitudDesarchivoForm.vue?vue&type=template&id=8ead1e4a&"
import script from "./SolicitudDesarchivoForm.vue?vue&type=script&lang=js&"
export * from "./SolicitudDesarchivoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports